var map = {
	"./PHOTO-2023-05-08-22-18-21.jpg": 961,
	"./desktop.png": 909,
	"./desktop1.png": 3411,
	"./desktop2.png": 3148,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./office.jpg": 3632,
	"./office1.jpg": 1345,
	"./samya.jpg": 3590,
	"./slogan1.jpg": 9767,
	"./slogan11.jpg": 6522,
	"./slogan111.jpg": 5114,
	"./slogan2.jpg": 1639,
	"./slogan22.jpg": 3994,
	"./slogan3.jpg": 758,
	"./statchio.jpg": 2055,
	"./wfc.jpg": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;